<template lang="pug">
.fam
  .title {{$t('me.fam.title')}}
  .subtitle {{$t('me.fam.subtitle')}}
  .slides
    fam-slides

  
</template>
<script>
import DatePicker from '@/components/res/DatePicker'
import Flex from '@/components/Flex'
import { mapMutations } from 'vuex'
import FamSlides from '@/components/me/FamSlides'
export default {
  name: 'Fam',
  components: { FamSlides, Flex, DatePicker },
  props: {},
  created() {},
  data() {
    return {
      timeTable: [],
    }
  },
  computed: {},
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    onNext() {},
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
@import "src/styles/res.sass"
.fam
  position: absolute
  width: 100%
  height: 100%
  overflow: hidden
  .title
    //font-size: pxToRem(54)
    padding-left: pxToRem(40)
  .subtitle
    //font-size: pxToRem(26)
    padding-left: pxToRem(40)
    //color: $cl-gray
  .slides
    margin-top: pxToRem(200)
    width: 100%
.slide-enter-active, .slide-leave-active
  transition: all 0.5s
.slide-enter, .slide-leave-to
  transform: translateX(-100%)
</style>
